module.exports = __webpack_public_path__ + "static/img/dalian.dce9fd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/dalian.png
// module id = udyG
// module chunks = 93